const routesConfig = [
    {
      path: "/dashboard",
      component: "Dashboard",
      roles: ["user", "admin"], // Доступ для всіх користувачів
    },
    {
      path: "/admin",
      component: "Admin",
      roles: ["admin"], // Тільки для адміністраторів
    },
    {
      path: "/admin/users",
      component: "adminUsers",
      roles: ["admin"], // Тільки для адміністраторів
    },
    
    {
      path: "/admin/upload-incomings",
      component: "AddIncomingTab",
      roles: ["admin"], // Тільки для адміністраторів
    },
    {
      path: "/admin/addnewuser",
      component: "AddNewUser",
      roles: ["admin"], // Тільки для адміністраторів
    },
    {
      path: "/admin/driver-raport",
      component: "adminDriverRaport",
      roles: ["admin"], // Тільки для адміністраторів
    },
    {
      path: "/incoming",
      component: "AddIncomingTab",
      roles: ["admin"], // Тільки для адміністраторів
    },
    {
      path: "/admin/incoming-preview/:service",
      component: "IncomingPreview",
      roles: ["admin"], // Тільки для адміністраторів
    },
    {
      path: "/add-freenow-info",
      component: "AddFreeNowInfo",
      roles: ["admin"], // Тільки для адміністраторів
    },
    {
      path: "/add-freenow-info/:id",
      component: "AddFreeNowInfo",
      roles: ["admin"], // Тільки для адміністраторів
    },
    {
      path: "/edit-freenow-info",
      component: "EditFreeNowInfo",
      roles: ["admin"], // Тільки для адміністраторів
    },
    {
      path: "/freenow/records",
      component: "EditFreeNowInfo",
      roles: ["admin"], // Тільки для адміністраторів
    },
    {
      path: "/admin/driver-debts",
      component: "adminDriversDebts",
      roles: ["admin"], // Тільки для адміністраторів
    },
    {
      path: "/admin/driver-debts/:id",
      component: "DriverDebtDetails",
      roles: ["admin"], // Тільки для адміністраторів
    },
    {
      path: "/admin/driver-extra-funds",
      component: "DriverExtraFunds",
      roles: ["admin"], // Тільки для адміністраторів
    },
    {
      path: "/admin/edit-extra-funds",
      component: "DriverExtraFundsEdit",
      roles: ["admin"], // Тільки для адміністраторів
    },
    {
      path: "/admin/edit-extra-funds/:id",
      component: "DriverExtraFundsEdit",
      roles: ["admin"], // Тільки для адміністраторів
    },
    {
      path: "/admin/cash-stats",
      component: "CashStats",
      roles: ["admin"], // Тільки для адміністраторів
    },
    {
      path: "/admin/cash-data",
      component: "CashStats",
      roles: ["admin"], // Тільки для адміністраторів
    },
    {
      path: "/instructions",
      component: "Instructions",
      roles: ["admin"], // Тільки для адміністраторів
    },
    {
      path: "/admin/edit-source-data/:service",
      component: "editSourceData",
      roles: ["admin"], // Тільки для адміністраторів
    },
    {
      path: "/admin/weekly-stats",
      component: "weeklyStats",
      roles: ["admin"], // Тільки для адміністраторів
    },
    {
      path: "/admin/check-reports",
      component: "adminRaports",
      roles: ["admin"], // Тільки для адміністраторів
    },
    {
      path: "/settings",
      component: "UserSettings",
      roles: ["user", "admin"]
    },
    {
      path: "/admin/settings",
      component: "siteSettings",
      roles: ["admin"]
    },
    {
      path: "/user/dashboard",
      component: "UserDashboard",
      roles: ["admin", "user"]
    },
    {
      path: "/user/raport",
      component: "UserRaport",
      roles: ["admin", "user"]
    },
    {
      path: "/user/report/:id", 
      component: "UserRaport",
      roles: ["admin", "user"]
    },

    
    
  ];
  
  export default routesConfig;
  